import React from 'react';
import { useTranslation } from 'react-i18next';
import AuthLayout from './AuthLayout';

export const Unauthorized = () => {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <h1>{t('unauthorized')}</h1>
    </AuthLayout>
  );
};

export default Unauthorized;
